// extracted by mini-css-extract-plugin
export default {"mainContainer":"LogoEdit_mainContainer__Kdqri","labelBox":"LogoEdit_labelBox__ILtG+","InputBox":"LogoEdit_InputBox__vJuP8"};